<nb-layout>
    <nb-layout-column>
        <main>

            <div class="form">
                <h3>Modify </h3>

                <form [formGroup]="fg" (ngSubmit)="onSubmit()">


                    Name: <input nbInput type="text" formControlName="name" value={{painting[0]?.name}}>
                    Year: <input nbInput type="number" formControlName="year" value={{painting[0]?.year}}>
                    Description: <input nbInput type="string" formControlName="description"
                        value={{painting[0]?.description}}>
                    Dimensions: <input nbInput type="string" formControlName="dimensions"
                        value={{painting[0]?.dimensions}}>
                    Available:
                    <nb-select class="select" formControlName="available" placeholder="{{painting[0]?.available}}">
                        <nb-option value="yes">yes</nb-option>
                        <nb-option value="no">no</nb-option>
                    </nb-select>

                    Choose image: <input nbInput formControlName="pImage" type="file"
                        (change)="onFileSelected($event)" />

                    <button nbButton size="small" type="submit" [disabled]="fg.invalid">Modifier</button>

                </form>

            </div>

            <div class="img"
                style=" background-image: url(https://api-petar.herokuapp.com/{{painting[0]?.pImage}})"></div>


        </main>

    </nb-layout-column>

</nb-layout>